'use client'
import {SessionProvider} from "next-auth/react";

export const UseSessionClient = ({children}) => {
    return <SessionProvider basePath="/api/nextapi/auth">{children}</SessionProvider>
}
